import { VerticalContainer } from "@shared/designSystem/Containers";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

// Animation (20 s, 4 steps) showing how to copy coordinates from Google Maps and
// paste them in Qontact. Served from public/ so it doesn't depend on an external site.
const coordinatesHelpVideoURL = `${process.env.PUBLIC_URL}/videos/coordenadas-qontact-point.mp4`;

interface CoordinatesHelpVideoProps {
    /**
     * true: just the video, filling its container (e.g. inside the "Nuevo Qontact
     * Point" modal). false (default): standalone card for a popup, with a title.
     */
    embedded?: boolean;
}

/**
 * "¿Cómo copiar coordenadas desde Google Maps?" help. Shown in a popup from the
 * qontact point Información tab and inline in the new qontact point modal.
 */
export const CoordinatesHelpVideo: React.FC<CoordinatesHelpVideoProps> = ({ embedded = false }) => {
    const video = (
        <video
            src={coordinatesHelpVideoURL}
            controls
            autoPlay
            playsInline
            style={{ width: "100%", height: "auto", borderRadius: designSystemStyles.cornerRadiusComponent }}
        />
    );

    if (embedded) {
        return video;
    }

    return (
        <VerticalContainer
            width="min(80vw, 960px)"
            gap={designSystemStyles.gapSm}
            padding={designSystemStyles.paddingMd}
            backgroundColor={designSystemStyles.colorBackgroundWhite}
            borderRadius={designSystemStyles.cornerRadiusComponent}
        >
            <Text
                text={`**${"Cómo copiar coordenadas desde Google Maps".localized()}**`}
                markdown={true}
            />
            {video}
        </VerticalContainer>
    );
};

export default CoordinatesHelpVideo;
